import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useMutation } from 'react-query';
import { createVeriffFrame, MESSAGES } from '@veriff/incontext-sdk';
import { useTranslation } from 'react-i18next';
import { showAlert } from '../../utilities/notifications';
import { KYC_REQUEST_SESSION } from './mutations';
import { FLOWS, sendStats } from '../../services/mixpanel';
import {
  MXP_ONBOARDING_SIGN_UP_KYC_SUBMITTED,
  MXP_ONBOARDING_SIGN_UP_KYC_START_SESSION,
} from '../Onboarding/mixpanel-events';
import { useSetting } from '../../utilities/sharedHooks/settings';
import { peekKycReturnUrl } from '../Oauth/kycReturn';

const KYCJourney = () => {
  const history = useHistory();
  const { state } = useLocation();

  const { t: translate } = useTranslation();

  const [totpFeatureEnabled] = useSetting('app_features', 'feature_allow_totp');

  const [veriffSDK, setVeriffSDK] = useState(null);

  const [sessionUrl, setSessionUrl] = useState(null);

  const { mutate: requestSessionUrlAsync } = useMutation(KYC_REQUEST_SESSION, {
    onSettled: (data, error) => {
      if (!error) {
        sendStats(MXP_ONBOARDING_SIGN_UP_KYC_START_SESSION, { data }, FLOWS.ONBOARDING);
        setSessionUrl(data);
      } else {
        showAlert({
          message: error?.message || translate('generic_error_msg'),
          type: 'danger',
        });
      }
    },
  });

  useEffect(() => {
    if (veriffSDK === null) {
      requestSessionUrlAsync();
    } else {
      veriffSDK.close();
      requestSessionUrlAsync();
    }

    return () => {
      if (veriffSDK) {
        veriffSDK.close();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (sessionUrl && typeof sessionUrl === 'string') {
      const veriffSDKValue = createVeriffFrame({
        url: sessionUrl,
        lang: 'en',
        onEvent(msg) {
          if (msg === MESSAGES.FINISHED || msg === MESSAGES.CANCELED) {
            sendStats(
              MXP_ONBOARDING_SIGN_UP_KYC_SUBMITTED,
              { kycProviderMessage: msg },
              FLOWS.ONBOARDING
            );
            if (
              state?.signupFlow &&
              !state?.user?.totp_enabled &&
              totpFeatureEnabled &&
              state?.user?.totp_active
            ) {
              history.push(`/onboarding/totp`, { ...state, signupFlow: true });
            } else if (peekKycReturnUrl()) {
              // Verification resolves asynchronously, so an interrupted OAuth
              // journey waits on the pending screen rather than the dashboard.
              history.push(`/kyc/pending`);
            } else {
              history.push(`/`, { showPromo: true });
            }
          }
        },
      });
      setVeriffSDK(veriffSDKValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionUrl]);

  return <></>;
};

export default KYCJourney;
